import { formatNumber } from 'utils/numberFormat';
import { HTMLAttributes, memo, useState } from 'react';
import { useTranslate } from '@tolgee/react';
import { DownOutlined } from '@ant-design/icons';
import Fold from './Fold';
import { DetailItem, Amount, Detail, priceRender } from './TradeDetailPaymentLazada';
import { LIHeaderChild } from './LIHeaderChild';
import { cx } from '@emotion/css';

export interface TradeIncomeAmountProps extends HTMLAttributes<HTMLElement> {
  trade: Conversation.Trade.Vo;
  defaultFold?: boolean;
}

function TradeDetailIncomeMercado(props: TradeIncomeAmountProps) {
  const { trade, defaultFold = true, className, ...otherProps } = props;

  const { unit, tradeIncome } = trade;

  const { t } = useTranslate();

  const [isfold, setIsfold] = useState(defaultFold);

  const isTradeDetail = className === 'tradeDetail';

  const totalIncome = tradeIncome?.escrowAmount;
  const total = priceRender(totalIncome, (val) => {
    return (
      <DetailItem
        key="escrowAmount"
        onClick={() => setIsfold((isfold) => !isfold)}
        className={
          isTradeDetail
            ? 'border border-solid border-[#F0F2F5] px-4 py-0 leading-[40px]'
            : undefined
        }
      >
        <span className={isTradeDetail ? 'font-bold' : undefined}>{t('trade.订单收入')}</span>
        {!isTradeDetail ? (
          <Amount isfold={isfold}>
            <div>{`${unit} ${formatNumber(val, '0,0.00')}`}</div>
            <DownOutlined />
          </Amount>
        ) : null}
      </DetailItem>
    );
  });

  const detail = (
    <Detail
      key="detail"
      className={cx([
        '!px-0',
        isTradeDetail
          ? '!bg-fill-0 !px-0 border-t-0 border border-solid border-[#F0F2F5]'
          : undefined,
      ])}
    >
      <div className="px-4">
        {priceRender(tradeIncome?.orderAmount, (val) => {
          return (
            <li>
              <dt>{t('销售金额(收入)')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </li>
          );
        })}
        {priceRender(tradeIncome?.orderAmount, (val) => {
          return (
            <LIHeaderChild>
              <dt>{t('销售额')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </LIHeaderChild>
          );
        })}
        {priceRender(tradeIncome?.cancelPrice, (val) => {
          return (
            <LIHeaderChild>
              <dt>{t('平台佣金(支出)')}</dt> <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </LIHeaderChild>
          );
        })}
        {priceRender(tradeIncome?.refundItemPrice, (val) => {
          return (
            <LIHeaderChild>
              <dt>{t('部分退款')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </LIHeaderChild>
          );
        })}
        {priceRender(tradeIncome?.commissionFee, (val) => {
          return (
            <li>
              <dt>{t('平台佣金(支出)')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </li>
          );
        })}
        {priceRender(tradeIncome?.commissionFee, (val) => {
          return (
            <LIHeaderChild>
              <dt>{t('平台佣金(支出)')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </LIHeaderChild>
          );
        })}
        {priceRender(tradeIncome?.commissionFeeReturn, (val) => {
          return (
            <LIHeaderChild>
              <dt>{t('平台退回佣金')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </LIHeaderChild>
          );
        })}
        {priceRender(tradeIncome?.shippingFee, (val) => {
          return (
            <li key="shippingFee">
              <dt>{t('运费小计(实际)')}</dt>
              <dd>{`${unit} ${formatNumber(val, '0,0.00')}`}</dd>
            </li>
          );
        })}
      </div>
    </Detail>
  );

  return total ? (
    <Fold
      isfold={isfold}
      fixedCount={1}
      nodeList={[total, detail]}
      defaultFixedHeight={32}
      {...otherProps}
      className={isTradeDetail ? 'mb-4' : undefined}
    />
  ) : null;
}

export default memo(TradeDetailIncomeMercado);
